import { action } from 'satcheljs';

/**
 * Action that discards the changes made to option
 */
export const discardAccessibilityOption = action('discardAccessibilityOption');

/**
 * Action that toggles the state of option
 */
export const toggleAccessibilityOption = action(
    'toggleAccessibilityOption',
    (selectedOption: boolean) => ({ selectedOption })
);
